import React from "react";
import TooltipTrigger from "react-popper-tooltip";

import { Container } from "./style";

const MenuButton = ({ children, content, ...props }) => (
  <TooltipTrigger
    {...props}
    tooltip={({ tooltipRef, getTooltipProps, placement }) => (
      <Container
        {...getTooltipProps({
          ref: tooltipRef,
          "data-placement": placement
        })}
      >
        {content}
      </Container>
    )}
  >
    {({ getTriggerProps, triggerRef }) => (
      <div>
        <span
          {...getTriggerProps({
            ref: triggerRef
          })}
          css={`
            display: inline-block;
          `}
        >
          {children}
        </span>
      </div>
    )}
  </TooltipTrigger>
);

MenuButton.defaultProps = {
  placement: "bottom-start",
  trigger: "click"
};

export default MenuButton;
